module.exports = __webpack_public_path__ + "img/image_body-point_01_03.f0789716.svg";